export default __webpack_public_path__ + "static/media/frg--outdoor-lagoon-pool.bb5f4f01.png";